<template>
  <div id="clause">
    <div class="bar">
      <y-d-tab-bar />
    </div>
    <div class="container">
      <div class="tab">
        <el-cascader-panel v-model="clause" :options="options"></el-cascader-panel>
      </div>
      <div class="clause_content">
        <clause-container :clause="clause" />
      </div>
    </div>
    <footer>
      <y-d-f-y-footer-bar />  
    </footer>
  </div>
</template>

<script>
import YDTabBar from './../components/YDTabBar'
import YDFYFooterBar from './../components/YDFYFooterBar'
import ClauseContainer from './../components/ClauseContainer'
export default {
  name: 'Clause',
  data() {
    return {
      clause: ['search'],
      options: [
        {
          value: 'search',
          label: '服务条款',
        }, 
        {
          value: 'policy',
          label: '隐私政策',
        },
        {
          value: 'statement',
          label: '免责声明',
        }
      ]
    }
  },
  mounted () {
    window._rlog.push(["_trackEvent", 'terms_visit']);
  },
  watch: {
    '$route'(to, from) {
      if (to.query.clause !=undefined) {
        let clause = []
        clause.push(to.query.clause)
        this.clause = clause
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (to.query.clause != undefined) {
      let clause = []
      clause.push(to.query.clause)
      next(vm => {
        vm.clause = clause
      })
    }
    next()
  },
  components: {
    YDTabBar,
    YDFYFooterBar,
    ClauseContainer
  }
}
</script>

<style scoped>
#clause .bar{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 99;
  background-color: #fff;
}
#clause .container {
  max-width: 1440px;
  min-width: 1106px;
  overflow: hidden;
  margin: 0 auto;
}
.tab {
  width: 154px;
  height: 100%;
  position: fixed;
  top: 72px;
}
.clause_content {
  padding: 72px 40px 250px 226px;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
}
footer {
  width: 100%;
  height: 103px;
  overflow: hidden;
  margin: 0 auto;
  position: fixed;
  bottom: 0;
}
.footer_products {
  text-align: center;
}
.footer_products a:last-child {
  border: 0;
}
.footer_products a {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(164,164,164,1);
  line-height: 17px;
  padding: 0 12px;
  display: inline-block;
  margin-bottom: 9px;
  border-top: 0;
  border-bottom: 0;
  border-left: 0;
  border-right: 2px;
  border-color: #E8E8E8;
  border-style: solid;
}
.footer_version {
  width: 100%;
  height: 17px;
  font-size: 12px;
  font-weight:600;
  color:rgba(188,188,188,1);
  line-height: 17px;
  text-align: center;
  margin-bottom: 30px;
}
</style>
<style>
.el-scrollbar__wrap {
  overflow: visible !important;
}
</style>

